/* eslint-disable no-console */

import { register } from 'register-service-worker'

// The app's global snackbar (this.notify()) has no template that actually
// renders it anywhere, so the update prompt is built as a small self-contained
// DOM banner instead of relying on Vuex/Vue state.
function showUpdateBanner () {
  if (document.getElementById('sw-update-banner')) return

  const banner = document.createElement('div')
  banner.id = 'sw-update-banner'
  banner.setAttribute('dir', 'rtl')
  banner.style.cssText = [
    'position:fixed', 'left:16px', 'right:16px',
    'bottom:calc(env(safe-area-inset-bottom, 0px) + 16px)',
    'z-index:2147483647', 'background:#39506D', 'color:#fff',
    'padding:12px 16px', 'border-radius:12px',
    'box-shadow:0 6px 20px rgba(0,0,0,0.25)',
    'display:flex', 'align-items:center', 'justify-content:space-between',
    'gap:12px', 'font-family:inherit', 'font-size:13px', 'max-width:420px',
    'margin:0 auto',
  ].join(';')

  const text = document.createElement('span')
  text.textContent = 'نسخه جدیدی در دسترس است'
  banner.appendChild(text)

  const button = document.createElement('button')
  button.textContent = 'بروزرسانی'
  button.style.cssText = [
    'background:#fff', 'color:#39506D', 'border:none', 'border-radius:8px',
    'padding:6px 14px', 'font-weight:bold', 'font-size:13px', 'cursor:pointer',
    'flex-shrink:0',
  ].join(';')
  button.onclick = () => window.location.reload()
  banner.appendChild(button)

  document.body.appendChild(banner)
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      showUpdateBanner()
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
